var _defs, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeworkWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3432 2083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #e31e26;\n      }\n\n      .cls-5 {\n        fill: #f9a51a;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-7 {\n        fill: #d7e159;\n      }\n\n      .cls-8 {\n        fill: #edd8ce;\n      }\n\n      .cls-9 {\n        fill: #b2d236;\n      }\n\n      .cls-10 {\n        fill: #e88b24;\n      }\n\n      .cls-11 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-12 {\n        fill: #541334;\n      }\n\n      .cls-13 {\n        opacity: .23;\n      }\n\n      .cls-14 {\n        fill: #1f519e;\n      }\n\n      .cls-15 {\n        fill: #db3a5d;\n      }\n\n      .cls-16 {\n        fill: #0c192d;\n      }\n\n      .cls-17 {\n        fill: #e2dae5;\n      }\n\n      .cls-18 {\n        fill: #b5d348;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-20 {\n        fill: #467e3b;\n      }\n\n      .cls-21 {\n        fill: none;\n      }\n\n      .cls-22 {\n        fill: #fcee4d;\n      }\n\n      .cls-23 {\n        fill: #fcc612;\n      }\n\n      .cls-24 {\n        fill: #612c85;\n      }\n\n      .cls-25 {\n        fill: #85b13f;\n      }\n\n      .cls-26 {\n        fill: #221f1f;\n      }\n\n      .cls-27 {\n        fill: #ee9f20;\n      }\n\n      .cls-28 {\n        fill: #d2ba9e;\n      }\n\n      .cls-29 {\n        fill: #f2f9fd;\n      }\n\n      .cls-30 {\n        fill: #4a256b;\n      }\n\n      .cls-31 {\n        fill: #6a4;\n      }\n\n      .cls-32 {\n        fill: #92c640;\n      }\n\n      .cls-33 {\n        fill: #faad3c;\n      }\n\n      .cls-34 {\n        fill: #839d59;\n      }\n\n      .cls-35 {\n        fill: #579542;\n      }\n\n      .cls-36 {\n        fill: #c4d94a;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 2971.14,
    y: 245.91,
    width: 461.48,
    height: 689.16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1.86,
    y: -7.1,
    width: 3439.54,
    height: 2098.29
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2843.1,1716.11c47.85,54.96,167.08,108.45,338.67-40.17,32.89,.79-.84,127.26-153.73,150.27,92.24,20.17,200.74-88.44,227.72-63.89,19.24,19.59-37.48,142.61-232.24,108.99,42.61,22.47,128.63-1.91,140.71,31.8-58.44,72.12-308.48,25.53-404.8-185.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2839.38,1692.51c36.7,43.31,111.97,60.51,160.34,53.98-17.36,20.86-85.29,30.28-121.98,19.72,47.18,49.76,108.28,77.23,108.28,77.23-40.22,10.07-114.11-9.44-157.1-58.07,39.9,55.35,93.27,94.88,105.21,100.77-81.47-2.97-160.32-67.9-173.15-143.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2830.44,1722.83c38.85,20.39,100.03,32.21,100.03,32.21-76.67,2.94-126.37-19.18-126.37-19.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2826.7,1728.07c15.71,31.52,62.07,77.72,86.74,90.28-54.95-19.6-114.54-85.18-113.19-88.54,1.36-3.36,10.09,83.22,65.14,122.39-56.5-35.73-83.82-87.65-82.7-122.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2966.76,1779.86c60.27-14.15,119.86-51.55,125.27-47.69,5.41,3.83,10.04,5.24,10.04,5.24,0,0-1.85-10.36,1.52-13.89,25.02-26.99,73.65-53.44,80.56-46.58,8.97,24.79-42.15,91.11-89.94,112.04-8.49-.83-29.1-8.57-29.1-8.57l8.72,18.81c-25.7,18.3-77.9,11.66-93.47-2.25,66.81-18.25,136.93-47.1,174.25-81.13-84.35,46.42-136.41,63.45-187.85,64.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M3037.81,1833.35c46.18-3.14,192.13-93.33,217.94-71.03,2.68,40.18-67.31,89.56-119.95,96.09-7.78-.9-23.11-12.22-23.11-12.22l5.25,17.46c-37.1,9.03-112.73-1.9-158.59-41.01,80.79,32.04,175.95,27.15,265.39-34.84-65.28,30.74-135.25,47.14-186.92,45.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2964.85,1859c43.36,5.77,180.69,13.93,197.81,40.76-6.34,18.71-90.67,25.95-115.11,19.78-6.45-6.68-14.57-21.64-14.57-21.64l-.52,17.5c-33.96-.73-98.48-31.61-126.86-70.12,59.47,43.99,150.89,56.38,217.13,54.79-72.55-10.64-157.87-41.07-157.87-41.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2167.05,1372.68c-80.27-6.03-148.78,36.55-139.73,54.83,6.21,12.64,82.47-22.37,155.66,3.03,27.47,6.63,41.24-31.6,16.82-48.84-24.41-17.23-32.74-9.02-32.74-9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2199.54,1361.7c-67.65-55.04-125.95-35.93-127.37-55.44-1.44-19.52,119.72-36.83,187.34,18.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2227.09,1340.06c-76.53-47.92-233.75-9.15-239.86,56.66,45.52-16.03,118.91-35.52,194.36,3.22,47.1,14.83,64.07-48.29,45.51-59.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2371.16,1381.32c-95.55-140.86-240.19-109.85-174.81-73.83-85.94-13.55-56.98,38.32,3.19,54.21-78.95-1.96-97.54,61.79-11.87,54.88-55.41,6.57-56.02,44.88,11.74,41.1,52.63,20.52,92.37,61.47,162.31,21.57,69.99-39.92,9.44-97.94,9.44-97.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2327.27,1337.43c-48.49-48.9-120.71-64.13-142.22-44.1,17.03,19.22,69.4,19.75,124.6,64.09,2.8-4.49-18.53-33.45-62.52-52.65,37.05,8.71,73.69,44.02,80.14,32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2279.53,1356.19c-34.37-35.6-124.54-69.17-149.11-37.3,9.42,32.96,87.21,45.05,127.94,75.38-9.94-12.49,.95-28.12,.95-28.12-13.85-15.33-94.81-41.94-94.81-41.94,44.85-3.31,99.55,35.01,99.55,35.01,7.84-3.25,15.48-3.03,15.48-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2226,1382.59c-38.06-20.68-100.52,.84-91.11,22.04,9.44,21.2,52.53,3.98,67.12,11.38-7.72-7.29-4.99-13.92-4.99-13.92-15.43-2.16-47.7-1.75-47.7-1.75,17.64-11.41,52.93-6.03,52.93-6.03,10.79-6.15,23.74-11.73,23.74-11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2204.75,1427.83c-20.34-13.62-63.02,7.47-53.85,18.65,9.16,11.18,38.95,2.11,57.19,3.17-.91-5.85-4.98-10.1-4.98-10.1-9.97-3.89-36.71,.52-36.71,.52,11.92-9.02,38.35-12.24,38.35-12.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2131.46,1415.43c-42.83,2.33-99.99,18.84-104.15,12.09-4.19-6.74,40.52-30.59,95.65-37.23-5.36,11.49,8.5,25.14,8.5,25.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2099.45,1371.81c-37.75-6.91-106.04,18.68-117.72,34.6-13.51-21.68,84.21-83.82,166.87-58.88-12.62,3.28-19.54,9.64-19.54,9.64-19.24-8.49-65.89,5.32-65.89,5.32,17.03-.87,36.29,9.32,36.29,9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2123.33,1319.27c-29.13-3.99-54.23-5.62-51.16-13.01,3.06-7.35,42.43-14.01,77.1-6.59-23.41,1.74-25.93,19.6-25.93,19.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2438.34,1603.79c-53.15,39.67-174.2-10.49-228.21-94.1-45.71-70.74,3.61-64.1,46.22-32.07-100.65-91.86-4.12-116.02,60.48-67.08-64.6-48.94-7.19-79.22,33.23-28.39-43.17-52.32,18.97-55.66,78.92,35.52,56.58,86.06,54.11,152.73,9.36,186.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2439.56,1595.28c-41.82,52.4-158.25,1.5-208.06-57.11-48.03-56.48-5.9-53.22,55.45-20.68-38.7-31.13-64.03-71.64-57.36-85.46,7.51-15.55,50.94-6.21,108.65,32.49-27.28-25.11-65.68-54.89-52.5-68.88,13.18-14.02,64.93,57.13,64.93,57.13-26.49-34.53-32.57-72.53-17.31-70.11,60.42,9.56,155,151.49,106.21,212.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2428.05,1598.84c-37.36,29.07-170.44-3.31-112.76-56.25,57.66-52.95,156.81,22.06,112.76,56.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2327.86,1520.74c-20.88,15.98-70.39-27.23-49.46-44.26,20.9-17.01,92.63,11.24,49.46,44.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2308.39,1571.18c-16.4,4.12-72.62-19.89-56.46-41.45,16.17-21.5,87.65,17.47,59.98,39.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2428.4,1542.27c-9.52,9.25-37.96-16.95-27.07-27.06,10.91-10.17,36.61,17.83,27.07,27.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2377.36,1501.65c-8.58,3.51-32.5-11.09-20.36-20.43,12.08-9.31,33.83,14.96,20.36,20.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2585.69,1692.96c16.12,10.46-20.48,160.42-41.78,164.92-21.3,4.48-81.79-11.81-89.77,35.78,.47,6.95,4.46,11.91,9.38,12.6-2.07,.43-21.94,12.87-10.08,29.96,10.2,14.68,65.2-26.78,117.75-39.03,24.08-5.6,59.06,25.29,69.53,11.81,19.79-25.46-35.75-37.41-48.16-45.85-14.74-9.95,36.63-165.04,52.09-188.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2460.79,1924.41c4.44,9.47,35.21-13.25,61.56-27.07,26.32-13.82,50.07-24.04,73.4-12.92,23.32,11.13,38.73,26.38,42.86,11.96,5.01-17.42-33.48-25.15-50.87-29.53-17.38-4.39,6.46-103.75,21.9-141.62-7.79,4.2-22.61,7.38-22.61,7.38-10.06,36.77-19.65,131.89-51.65,130.83-31.98-1.08-58.41-3.27-70.4,9.61-11.97,12.88-1.34,24.77,8.72,16.01,10.02-8.76,32.9-8.34,42.65-7.95-31.57,10.03-54.42,19.63-56.63,28.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2445.34,1930.9c3.33,7.06,24.95-2.8,26.78-10.79,1.84-7.98-3.71-15.4-10.6-15.44-6.9-.03-19.83,18.45-16.18,26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2451.96,1896.04c3.31,7.06,21.74-2.58,23.57-10.58,1.84-7.95-.49-15.61-7.38-15.67-6.9-.02-19.85,18.45-16.19,26.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2446.02,1926.59c1.66,6.11,18.7-3.42,16.89-15.31-1.83-11.88-19.34,6.46-16.89,15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2647.38,1900.53c-1.63,7.96-24.59,6.28-28.07-.72-3.56-7,.12-16.11,6.72-18.66,6.63-2.49,23.11,10.59,21.35,19.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2645.79,1896.61c-.28,6.5-18.76,3.47-19.65-8.58-.87-12.05,20-.74,19.65,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2451.75,1889.56c1.59,6.15,20.31-.07,18.5-11.94-1.83-11.88-19.79,6.95-18.5,11.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2632.91,1764.5c-.54,15.05-28.68,51.43-51.36,47.2-19.81-3.67-31.07-29.9-33.86-65.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2554.9,1750.11c-7.12,17.88,.95,54.02,20.72,59.54,19.79,5.54,34.44-23.8,32.66-38.19-1.76-14.41-50.06-29.64-53.38-21.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2687.96,1259.18c-6.44,51.58,127.97,150.07,164.35,337.55,32.59,168.03-109.43,242.18-290,192.37-185.66-51.19-207.27-310.04-147.18-428.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2424.83,1245.25c19.75,28.29-13.02,101.4-21.02,133.62-11.97,48.21,84.4,515.61,274.91,296.61,53.63-61.65,101.98-259.83,112.69-307.67-5.98-22.98-88.1-71.57-82.33-223"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2564.49,1404.43c27.42,89.1,112.24,309.15,48.67,360.15-51.95,25.1-136.61-2.3-193.66-86.94-57.05-84.64-46.45-224.32-22.11-295.66,37.49-109.84,121.4-126.06,167.1,22.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2397.33,1472.29s-32.25,156.82,68.13,252.24c60.14,57.16,114.24,43.46,132.53,11.51,35.31-61.66-35.54-222.11-63.75-292.59-48.87-88.76-113.13-76.34-136.92,28.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2500.57,1599.35c32.93,15.9,116.7,153.84,20.85,131.51-95.84-22.32-122.27-111.51-112.18-133.82,10.09-22.31,44.54-20.3,91.33,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2567.58,1604.5c22.39,14.38,11.76,70.39-12.38,47.71-24.14-22.66-23.05-70.52,12.38-47.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2424.46,1546.78c23.25,6.09,42.85,35.15,10.78,34.64-32.04-.47-34.07-40.75-10.78-34.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2505.67,1571.34c18.41,7,12.8,28.43-5.1,28.01-17.85-.42-13.33-35.06,5.1-28.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2764.52,1937.45c3.48,11.95,11.2,48.55-25.92,45.31-26.23-2.27-8.28-38.46-28.25-45.89-19.97-7.47-69.97,11.64-78.5,1.18,1.03-35.9,64.6-22.18,72.42-41.12,4.79-29.86,1.51-72.55-5.59-112.33,8.34-3.06,16.29-7.63,23.55-13.37,7.79,61.73,22.14,122.42,36.66,127.89,15.62,6.45,74.73,28.87,55.04,57.25-19.69,28.37-45.21-18.48-49.41-18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2753.81,1898.12c-14.22-6.09-20.37-69.24-29.62-128.44-5.44,4.53-11.31,8.39-17.45,11.46,10.93,46.75,15.73,96.66,11.34,120.45-8.13,7.9-48.9,7.58-67.7,13.37-18.81,5.81-6.84,17.06-2.04,18.48,16.12-10.72,69.09-16.51,78.03-4.79,11.06,14.52-2.71,48.87,23.12,45.29,30.58-4.25,1.44-48.02,12.96-45.57,17.55,3.74,32.41,30.66,43.38,21.44,10.97-9.22,14.11-23.31-52.01-51.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2649.82,1918.08c5.76,2.49,9.27,10.84,6.09,15.05-3.17,4.21-26.04,6.99-26.68,3.62-1.38-7.21,12.99-21.92,20.6-18.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2641.41,1919.53c-11.9,5.45-12.09,19.66,1.92,13.17,14-6.47,8.67-18.02-1.92-13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2758.45,1963.47c-5.94-4.01-18.21-.98-20.63,4.47-3.48,7.79,7.44,26.18,11.5,24.31,8.72-4.01,18.77-22.3,9.13-28.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2760.88,1971.98c-1.52,13.47-14.84,18.51-17.6,3.63-2.75-14.89,18.91-15.19,17.6-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2808.59,1939.42c-6.43-.73-15.2,4.4-15.6,9.31-.4,4.95,16.25,18.13,19.15,15.71,6.22-5.19,4.97-24.04-3.55-25.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2815.28,1946.89c2.42,11.13-6.38,16.9-12.77,5.63-6.41-11.29,10.68-15.17,12.77-5.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2766.82,1762.12c5.58,17.63-15.72,72.95-46.95,78.85-27.23,5.13-52.79-19.8-71.47-60.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2664.75,1774.51c-1.77,24.04,24.51,59.42,46.97,55.7,19.52-3.22,25.59-46.32,17.27-62.1-8.32-15.79-63.41-4.79-64.24,6.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2571.8,877.42c31.8-.94,139.56-77.69,80.61-131.67,77.93,19.89,54.21,127.85,22.78,145.49,42.01,1.21,55.85-45.21,46.86-66.06,55.89,38.91,16.72,97.02-13.94,107.93,24.94-6.81,60.22,20.1,58.35,55.2-10.5-14.58-45.79-4.13-45.79-4.13,27.61,99.22-19.29,191.08-3.15,251.41,18.4,68.75-265.17,115.62-300.51-16.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2710.49,1116.12c43.76-105.05-44.27-261.19-190.89-251.52-152.15,10.04-164.35,167.63-178.56,214.83-45.2,69.74,25.63,141.37,97.7,141.34,92.24-.05,227.54,1.46,271.75-104.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2534.37,867.7c103.41,7.76,145.53,119.49,139.22,179.02,5.54,19.36,24.16,123.9-72.37,148.21-101.07,25.44-175.35,15.85-238.07-22.48-55.4-33.86-26.71-72.78-16.73-94.99,23.93-138.22,78.76-218,187.95-209.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2504.56,878.23c124.98,7.96,121.68,186.62-27.61,190.89-137.95,3.95-105.56-199.35,27.61-190.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2663.88,759.94c56.96,5.24,44.92,118.38-45.01,100.2,29.8-8.27,60.75-72.51,45.01-100.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2726.8,839.39c23.05,9.43,14.86,97.1-45.05,58.89,43.15-11.54,45.05-58.89,45.05-58.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2707.02,940.91c30.36-10.43,50.35-8.44,54.35,34.2-15.74-27.53-48.17-11.63-54.35-34.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2507.11,1067.49c-3.95-68.6,51.52-111.89,105.28-85.25,71.3,35.35,47.62,209.52-75.47,146.28"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2597.26,991.6c57.28,13.48,60.05,131.69-16.69,125.6-82.76-6.55-53.46-142,16.69-125.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2601.04,1011.42c45.98,10.79,52.54,110.31-13.41,100.81-65.93-9.44-42.9-114,13.41-100.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2535.46,1020.6c15.29-17.09,32.91,23.24,27.29,30.6-5.61,7.39-41.43-14.96-27.29-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2613.68,1066.2c7.42,.02,9.39,15.53-.66,13.87-10.03-1.74-7.68-13.9,.66-13.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2370.34,973.44c12.41-16.05,61.94-1.87,50.19,88.63-17.99,70.68-74.04,46.76-78.53,13.96,4.81-56.65,20.05-85.07,28.34-102.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2398.74,997.86c34.64,12.01,25.21,97.64-17.08,88.64-50.04-10.57-25.34-103.26,17.08-88.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2403,1006.41c28.73,9.85,20.89,80.93-14.23,73.46-41.47-8.81-20.94-85.61,14.23-73.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2361.14,1007.31c10.75-9.52,20.95,22.1,16.94,26.81-4.02,4.65-27.3-17.63-16.94-26.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2400.62,1047.15c4.83,.71,5.24,11.74-1.16,9.67-6.43-2.12-4.25-10.43,1.16-9.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2540.53,1116.78c2.25,2.38,5.14,6.16,6.38,11.31,2.86,11.92-5.53,21.3-19.53,41.91-21.76,32.04-19.62,36.06-30.97,43.77-6.24,4.24-21.15,14.36-37.62,9.07-9.15-2.95-19.19-10.78-21.74-21.54-4.15-17.5,13.64-34,26.21-45.67,12.36-11.47,36.71-30.07,77.27-38.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2479.17,1160.18c-5.81,2.09-9.2,6.05-10.39,7.58-4.63,5.95-4.9,12.34-4.97,14.79-.36,12.93,9.04,21.59,10.66,23.03,4.88-2.38,12.81-7.09,19.31-15.81,3.4-4.56,13.21-17.73,8.13-25.7-3.99-6.26-15.4-6.53-22.74-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2443.06,1210.35c-.78,.77,18.14,35.3,41.65,37.6,35.74,3.49,84.35-65.86,70.53-120.86-8.01-31.88-39.72-51.35-41.53-49.9-1.35,1.08,6.71,19.02,19.58,34.9,5.29,6.53,10.97,12.18,10.84,20.56-.09,5.63-2.76,10.11-4.66,13.3-3.4,5.7-7.52,9.02-15.62,15.42-3.14,2.48-7.48,5.74-12.91,9.28-4.76,10.9-10.53,18.89-15.31,24.43-5.87,6.81-23.57,27.32-40.02,23.58-8.05-1.83-12.2-8.66-12.55-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2511.4,1186.7c-1.43,21.52-13.35,36.96-28.75,42.95-12.72,4.91-29.77-8.88-29.77-8.88,19.52,2.02,44.24-8.82,58.53-34.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2505.64,1057.05c23.9,16.76,45.1,47.22,37.67,61.01-2.39,4.44-6.39,4.64-11.92,13.22-5.5,8.54-3.88,11.98-8.89,20.82-5.43,9.58-12.71,15.03-15.62,17.17-10.58,7.77-21.15,9.45-24.42,10.24-42.52,10.29-45.5,67.9-44.36,79.29-6.41,4-19.98-3.27-33.2-15.1,0,0-20.02-14.82-31.16-42.39-11.33-28.04-11.84-141.63,53.5-161.82,37.05-11.45,73.38,14.03,78.41,17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2451.05,1039.11c42.63-1.53,72.25,53.53,64.3,94.42-5.97,30.5-32.07,34.34-55.75,41.73-25.97,8.13-25.08,59.67-40.54,65.32-14.76,5.41-40.19-40.45-44.28-60.21-8.32-40.18-8.32-138.21,76.27-141.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2489.46,1102.71c7.53,3.53,23.12,18.56,10.62,24.14-12.59,5.64-15.95-26.63-10.62-24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2402.47,1079.58c14.9,3.89-4.2,60.06-16.05,61.25-18.19,1.86-18.07-70.18,16.05-61.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2617.62,1393.38c-21.62,125.38,38.33,238.64,75.16,251.18,26,44.31,66.07,85.8,84.01,74.39,9.06,25.63,79.46,35.78,78.92-20.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2882.12,1628.58c80.07,28.48,161.69,4.21,157.58-16.92-2.83-14.61-90.22-.18-157.69-46.42-26.1-14.43-50.78,20.67-30.71,45.04,20.05,24.34,30.82,18.3,30.82,18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2845.98,1630.7c53.53,74.91,118.24,71.66,114.26,91.92-3.97,20.27-132.18,4.18-185.7-70.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2811.87,1645.08c64.63,70.11,235.51,74.39,260.04,9.09-50.78,3.64-130.95,3.06-197.01-57.39-43.81-28.21-78.66,31.34-63.03,48.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2676.67,1562.96c58.07,170.03,214,178.72,157.44,123.84,83.76,37.73,68.7-23.17,11.87-56.1,79.85,23.98,116.52-35.76,27.34-52.57,58.26,8.73,69.56-30.11-.51-45.13-47.88-35.55-76.91-88.31-159.28-67.14-82.37,21.16-36.86,97.1-36.86,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2709.13,1619.88c35.78,63.3,105.07,98.91,132.56,84.51-11.98-24.34-65.19-39.45-109.03-99.98-4.1,3.8,9.56,39.24,49.02,71.02-35.33-19.18-62.81-65.34-72.55-55.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2762.99,1614.07c25.07,45.82,107.54,105.08,141.43,79.49-.4-36.19-76.25-70.16-109.26-112.38,6.64,15.49-8.81,28.36-8.81,28.36,9.83,19.47,84.86,69.12,84.86,69.12-46.58-9.12-91.63-63.38-91.63-63.38-8.87,1.14-16.59-1.2-16.59-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2824.86,1602.07c33,31.67,102.6,27.12,98.9,2.93-3.72-24.23-52.39-18.67-65.19-30.29,5.83,9.58,1.2,15.59,1.2,15.59,15.12,6.48,48.09,15.04,48.09,15.04-21.12,6.71-55.56-8.61-55.56-8.61-12.71,3.27-27.44,5.33-27.44,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2859.07,1561.93c16.93,19.51,66.25,9.93,60.05-4-6.2-13.94-39.09-13-57.37-19.16-.72,6.21,2.27,11.69,2.27,11.69,9.06,6.73,37.5,9.68,37.5,9.68-14.62,5.85-42.46,1.79-42.46,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2930.26,1594.95c44.26,9.56,107.07,8.67,109.43,16.71,2.37,8.01-49.78,19.87-107.78,11.27,8.67-10.21-1.65-27.98-1.65-27.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2950.72,1648.3c36.51,17.54,113.19,10.49,129.51-2.48,7.72,25.85-109.1,61.92-186.32,13.5,13.76,.16,22.57-4.38,22.57-4.38,17.25,14,68.6,12.91,68.6,12.91-17.58-3.85-34.36-19.56-34.36-19.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2911.77,1695.15c28.53,12.15,53.63,20.8,48.47,27.48-5.16,6.63-47.12,2.45-80.32-14.75,24.33,4.73,31.86-12.73,31.86-12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2672.46,1310.8c65.16-25.59,172.23,66.08,203.95,166.26,26.83,84.76-21.54,64.27-56.02,19.81,76.93,121.55-7.94,111.18-60.09,43.32,49.74,80.54-5.64,83.96-32.67,20.96-2.14,75.98-62.11,64.18-99.72-51.32-33.66-103.38-10.32-177.5,44.55-199.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2663.2,1305.63c78.86-38.28,164.96,62.94,199.38,136.48,33.19,70.88-8.83,55.84-62.23,5.64,30.73,42.48,45.25,90.77,34.61,102.99-11.97,13.74-53.6-7.88-101.58-63.34,20.76,33.16,51.61,74.18,34.27,84.76-17.32,10.62-50.19-76.24-50.19-76.24,3.03,40.6,8,60.86-7.58,65.65-31.63,9.79-97.08-82.09-85.51-178.55,9.71,44.96,46.14,82.16,46.14,82.16-32.03-54.68-44.87-141.31-7.31-159.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2691.45,1309.44c48.32-12.7,164.07,73.96,86.1,101.42-77.96,27.46-143.06-86.5-86.1-101.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2756.28,1426.85c26.91-6.85,57.03,55.63,29.66,63.48-27.37,7.85-85.25-49.34-29.66-63.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2796.12,1385.96c17.62,2.82,62.24,49.45,37.61,63.66-24.63,14.19-77.84-53.33-41.72-63.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2667.64,1364.21c13.09-5.03,29.81,32.21,15.03,37.53-14.79,5.32-28.13-32.51-15.03-37.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M2700.32,1424.84c9.79,.16,26.91,24.25,11.28,28.28-15.59,4.02-26.65-28.56-11.28-28.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2591.3,948.62c-53.77-1.3-98.5,44.73-99.9,102.81-1.4,58.08,41.06,106.21,94.83,107.5,53.77,1.3,98.5-44.73,99.9-102.81,1.4-58.08-41.06-106.21-94.83-107.5Zm-4.83,200.26c-48.64-1.17-87.04-44.71-85.77-97.23,1.27-52.53,41.72-94.16,90.36-92.98,48.64,1.17,87.04,44.71,85.77,97.23-1.27,52.53-41.72,94.16-90.36,92.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2367.29,1142.45c-2.07,1.36-9.13,1.62-13.73,.82-51.81-9.06-69.41-46.85-69.89-96.85-.5-52.54,39.18-91.57,87.82-90.4,44.06,1.06,66.39,33.93,71.76,79.72,.06,0,.11-.01,.18-.01,3.05,.05,6.24,.14,9.24,.69-5.13-51.57-31.58-89.25-80.94-90.44-53.77-1.3-95.96,42.15-97.36,100.22-1.4,58.08,23.66,99.02,78.95,107.12,4.63,.68,10.49,.43,13.79-.73-.22-3.3,.04-6.64,.18-10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2501.06,1019.35c-30.2-11.9-55.47-1.62-55.72-1.52l-5.03-11.87c1.22-.52,30.19-12.52,65.49,1.4l-4.73,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2677.55,1019.87h50.29c.55,0,.99,.45,.99,.99v10.05c0,.97-.79,1.75-1.75,1.75h-49.53v-12.8h0Z",
    transform: "translate(25.53 -64.89) rotate(1.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294.06,1006.03l61.6,1.02-4.05,12.84-61.39-1.14c-2.56-.06-4.58-2.19-4.52-4.74l2.31,.52c.11-4.51,1.54-8.6,6.05-8.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2373.6,1100.4c2.45-5.76,3.83-13.33,7.1-19.17l-101.68-2.45c-.75-.02-1.38,.57-1.39,1.31-.72,29.77,23.08,54.48,53.16,55.21l5.78,.14s.1,0,.15,0l5.78,.14c8.96,.22,17.46-1.74,25.01-5.35,.02-.68,.12-1.35,.32-2.03,.26-.57,.51-1.14,.77-1.71-.03-1.24,.19-2.48,.65-3.63,.42-7.88,1.48-15.72,4.36-22.47Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2022.46,1581.52c44.12,14.07,72.55,43.45,82.3,88.38,9.63,44.35-3.14,84.03-38.97,111.42-19.13,14.63-21.38,27.71-15.05,47.44,3,9.35,1,10.67-8.66,7.31-31.63-11-63.42-21.6-94.74-33.44-53.19-20.1-83.8-75.24-73.29-130.44,10.51-55.24,59.42-95.41,116.03-95.34,11.02,.02,21.9,1.33,32.38,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1926.94,1680.01c-6.83,0-12.39,5.52-12.39,12.3,0,6.79,5.56,12.31,12.39,12.31s12.39-5.52,12.39-12.31c0-6.78-5.56-12.3-12.39-12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1988.52,1680.01c-6.83,0-12.39,5.52-12.39,12.3,0,6.79,5.56,12.31,12.39,12.31s12.39-5.52,12.39-12.31c0-6.78-5.56-12.3-12.39-12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2050.12,1680.01c-6.83,0-12.39,5.52-12.39,12.3,0,6.79,5.56,12.31,12.39,12.31s12.39-5.52,12.39-12.31c0-6.78-5.56-12.3-12.39-12.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 3312.08,
    cy: 648.61,
    rx: 150.85,
    ry: 163.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3457.65,685.96c-7.18-7.12-18.72-6.08-24.81,1.53-20.08,36.23-58.88,60.78-103.45,60.78-5.69,0-11.28-.43-16.75-1.2l-64.71,41.88,12.8-62.59c-9.73-6.93-18.34-15.32-25.55-24.8-.04-.05-.08-.11-.12-.17-14.86-19.6-23.69-43.95-23.69-70.37,0-19.11,4.63-37.13,12.8-53.07,.08-.15,.16-.3,.23-.46,19.16-37,57.52-62.54,102.02-63.64,.51-.02,1.02-.03,1.53-.04,.48,0,.96-.04,1.45-.04,46.23,0,86.24,26.42,105.6,64.88,5.41,9.29,18.45,10.86,26.13,3.11l56.54-57.09c5.62-5.67,6.32-14.48,1.81-21.05-41.22-60.21-111.35-98.39-184.87-100.27-76.3-1.95-150.17,36.17-193.75,98.19-45.56,64.83-52.7,150.63-20.46,222.68,32.79,73.26,103.86,123.91,183.87,132.94,77.59,8.75,154.93-23.39,203.75-83.78,2.65-3.28,5.22-6.64,7.69-10.06,4.8-6.64,4.16-15.73-1.68-21.51l-56.38-55.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3274.28,622.83c-6.08,0-11.02,4.91-11.02,10.95s4.94,10.95,11.02,10.95,11.02-4.91,11.02-10.95c0-6.03-4.94-10.95-11.02-10.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3329.07,622.83c-6.08,0-11.02,4.91-11.02,10.95s4.94,10.95,11.02,10.95,11.02-4.91,11.02-10.95c0-6.03-4.94-10.95-11.02-10.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3383.87,622.83c-6.08,0-11.02,4.91-11.02,10.95s4.94,10.95,11.02,10.95,11.02-4.91,11.02-10.95c0-6.03-4.94-10.95-11.02-10.95"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeworkWeb);
export default __webpack_public_path__ + "static/media/Homework- web.fb689cdc2c68a451008c4faf30263d43.svg";
export { ForwardRef as ReactComponent };